export const getJSON = async function (baseUrl, folder, file, callback) {
  const response = await fetch(`${baseUrl}/${folder}/${file}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      cache: 'no-cache',
    },
  });

  if (response.status === 200) {
    callback(await response.json());
  } else {
    callback(await response.json(), response.status);
  }
};
